export const OVERVIEW = "OVERVIEW";
export const OVERVIEW_ERROR = "OVERVIEW_ERROR";
export const OVERVIEW_HIDE_ERROR = "OVERVIEW_HIDE_ERROR";
export const OVERVIEW_START_LOADER = "OVERVIEW_START_LOADER";
export const OVERVIEW_STOP_LOADER = "OVERVIEW_STOP_LOADER";
